export * as SimpleDate from './SimpleDate';

type Type = Date;

export function create(): Type {
	return new Date();
}

export function getDifferenceInDays(date1: Date, date2: Date): number {
	const msPerDay = 1000 * 60 * 60 * 24;
	const timeDiff = Math.abs(date1.getTime() - date2.getTime());
	return Math.floor(timeDiff / msPerDay);
}

export function toInputFieldDate(date: Type): string {
	const year: number = date.getFullYear();
	const month: string = ('0' + (date.getMonth() + 1)).slice(-2);
	const day: string = ('0' + date.getDate()).slice(-2);

	return `${year}-${month}-${day}`;
}

export function isDateDiffEqual(
	startDate: Date | string,
	endDate: Date | string,
	expectedDaysBetween: number
): boolean {
	const start = new Date(startDate);
	const end = new Date(endDate);

	const startMidnight = new Date(start.getFullYear(), start.getMonth(), start.getDate());
	const endMidnight = new Date(end.getFullYear(), end.getMonth(), end.getDate());

	if (endMidnight < startMidnight) {
		return false;
	}

	const diffTime = endMidnight.getTime() - startMidnight.getTime();
	const diffDays = diffTime / (1000 * 60 * 60 * 24);

	return diffDays === expectedDaysBetween;
}

export function isDateDiffEqualOrHigher(
	startDate: Date | string,
	endDate: Date | string,
	minDaysBetween: number
): boolean {
	const start = new Date(startDate);
	const end = new Date(endDate);

	const startMidnight = new Date(start.getFullYear(), start.getMonth(), start.getDate());
	const endMidnight = new Date(end.getFullYear(), end.getMonth(), end.getDate());

	if (endMidnight < startMidnight) {
		return false;
	}

	const diffTime = endMidnight.getTime() - startMidnight.getTime();
	const diffDays = diffTime / (1000 * 60 * 60 * 24);

	return diffDays >= minDaysBetween;
}
